import FilterFaqGallary from "../components/common/filter-gallary/filter-faq-gallary";
import BreadcrumbOne from "./../components/common/breadcrumb/breadcrumb-one";
export default function Faq() {
	return (
		<>
			<BreadcrumbOne title="Faq" />
			<FilterFaqGallary />
		</>
	);
}
